import {
  EditContextProvider,
  Form,
  SaveButton,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { PermissionButton } from 'src/routes/components/permission-button';
import { Resources } from '../../resource';
import { XBIT_RELAY_WITHDRAWAL_PROVIDER_CONFIGS_PERMISSION_RESOURCE } from './constants';
import WithdrawalProviderConfigForm from './WithdrawalProviderConfigForm';

const EditWithdrawalProviderConfig = ({
  id,
  record,
  onClose,
}: {
  id: string | number;
  record?: any;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.xbitRelayWithdrawalProviderConfigs,
    mutationMode: 'pessimistic',
    // The record is passed in from the list row, so skip the getOne fetch.
    queryOptions: { enabled: !record },
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.xbitRelayWithdrawalProviderConfigs.updateSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(
          error?.message || t('module.xbitRelayWithdrawalProviderConfigs.updateFailed'),
          { type: 'error' },
        );
      },
    },
  });

  const resolvedRecord = record ?? controller.record;
  if (!resolvedRecord) return null;

  return (
    <EditContextProvider value={{ ...controller, record: resolvedRecord, isLoading: false }}>
      <Form disableInvalidFormNotification>
        <DialogTitle>
          {t('module.xbitRelayWithdrawalProviderConfigs.editConfig')} — {id}
        </DialogTitle>
        <DialogContent>
          <WithdrawalProviderConfigForm />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton
            resource={XBIT_RELAY_WITHDRAWAL_PROVIDER_CONFIGS_PERMISSION_RESOURCE}
            action="write"
          >
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditWithdrawalProviderConfig;
